import type { SVGProps } from "react";
const SenecPictogramPlugType2 = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M11.9981 8C7.14137 11.6489 4 17.4576 4 24C4 26.7342 4.54921 29.3426 5.54426 31.719C5.75757 32.2285 6.34346 32.4685 6.85289 32.2552C7.36232 32.0419 7.60238 31.456 7.38907 30.9466C6.49463 28.8104 6 26.4642 6 24C6 18.3455 8.60733 13.2999 12.6853 10H35.3147C39.3927 13.2999 42 18.3455 42 24C42 33.9411 33.9411 42 24 42C18.406 42 13.4086 39.4494 10.1056 35.444C9.75422 35.0179 9.12396 34.9573 8.69787 35.3087C8.27177 35.6601 8.2112 36.2903 8.56257 36.7164C12.2292 41.1628 17.7837 44 24 44C35.0457 44 44 35.0457 44 24C44 17.4576 40.8586 11.6489 36.0019 8H11.9981Z"
            fill="currentColor"
        />
        <path
            d="M18 12C19.6569 12 21 13.3431 21 15C21 16.6569 19.6569 18 18 18C16.3431 18 15 16.6569 15 15C15 13.3431 16.3431 12 18 12Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 23C7 20.2386 9.23858 18 12 18C14.7614 18 17 20.2386 17 23C17 25.7614 14.7614 28 12 28C9.23858 28 7 25.7614 7 23ZM12 20C10.3431 20 9 21.3431 9 23C9 24.6569 10.3431 26 12 26C13.6569 26 15 24.6569 15 23C15 21.3431 13.6569 20 12 20Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 23C19 20.2386 21.2386 18 24 18C26.7614 18 29 20.2386 29 23C29 25.7614 26.7614 28 24 28C21.2386 28 19 25.7614 19 23ZM24 20C22.3431 20 21 21.3431 21 23C21 24.6569 22.3431 26 24 26C25.6569 26 27 24.6569 27 23C27 21.3431 25.6569 20 24 20Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 33C13 30.2386 15.2386 28 18 28C20.7614 28 23 30.2386 23 33C23 35.7614 20.7614 38 18 38C15.2386 38 13 35.7614 13 33ZM18 30C16.3431 30 15 31.3431 15 33C15 34.6569 16.3431 36 18 36C19.6569 36 21 34.6569 21 33C21 31.3431 19.6569 30 18 30Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36 18C33.2386 18 31 20.2386 31 23C31 25.7614 33.2386 28 36 28C38.7614 28 41 25.7614 41 23C41 20.2386 38.7614 18 36 18ZM33 23C33 21.3431 34.3431 20 36 20C37.6569 20 39 21.3431 39 23C39 24.6569 37.6569 26 36 26C34.3431 26 33 24.6569 33 23Z"
            fill="currentColor"
        />
        <path
            d="M33 15C33 13.3431 31.6569 12 30 12C28.3431 12 27 13.3431 27 15C27 16.6569 28.3431 18 30 18C31.6569 18 33 16.6569 33 15Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 28C27.2386 28 25 30.2386 25 33C25 35.7614 27.2386 38 30 38C32.7614 38 35 35.7614 35 33C35 30.2386 32.7614 28 30 28ZM27 33C27 31.3431 28.3431 30 30 30C31.6569 30 33 31.3431 33 33C33 34.6569 31.6569 36 30 36C28.3431 36 27 34.6569 27 33Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramPlugType2;
